package app.nestbridge.feature.children.screen

import com.karawek.core.circuit.Parcelize
import app.nestbridge.feature.children.model.Child
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.PopResult
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data object ChildListScreen : Screen

@Parcelize
data class ChildListResult(
    val status: Status,
) : PopResult {
    enum class Status { Completed, Skipped }
}

data class ChildListState(
    val children: List<Child>,
    val childTeamCounts: Map<String, Int>,
    val childPendingInvitations: Map<String, Boolean>,
    val hasAnyChildWithTeam: Boolean,
    val isLoading: Boolean,
    val eventSink: (ChildListEvent) -> Unit,
) : CircuitUiState

sealed interface ChildListEvent {
    data object OnAppear : ChildListEvent
    data class SelectChild(val childId: String) : ChildListEvent
    data object AddChild : ChildListEvent
    data object ScanQRCode : ChildListEvent
    data object Skip : ChildListEvent
}
